import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as CloseModal } from "../../assets/svg/close-modal.svg";
import { ReactComponent as WebsiteIC } from "../../assets/svg/website-icon.svg";
import { ReactComponent as WebsiteEditIC } from "../../assets/svg/website-edit-icon.svg";
import WebsiteDetailsWidget from "./webscraping";
import { getWebScrapingApi } from "../leads/leads-api";
import { ReactComponent as InstaIc } from "../../assets/svg/insta_ic.svg";
import { ReactComponent as XIC } from "../../assets/svg/x-ic.svg";
import { ReactComponent as LinIC } from "../../assets/svg/linkden_ic.svg";
import { ReactComponent as YoutIC } from "../../assets/svg/youtub_ic.svg";
import { ReactComponent as FasIC } from "../../assets/svg/fas_ic.svg";

export default function WebSiteSearchModal({
  open,
  website,
  onEdit,
  onClose,
  onDataSubmit,
}) {
  const [webScrapDetails, setWebScrapDetails] = useState({});
  const [serviceList, setServicesList] = useState([]);
  const [industriesList, setIndustriesList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [teamList, setTeamsList] = useState([]);
  const [partnerList, setParnterList] = useState([]);
  const [payLinkDetails, setPageDetails] = useState({});
  const [payLinkList, setPageLinList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [peopleList, setPeopleList] = useState([]);
  const [careersList, setCareersList] = useState({});

  const [errorMsg, setErrorMsg] = useState({
    url: "",
  });
  const [socialLinks, setSocialLinks] = useState([]);
  const [aboutList, setAboutList] = useState([]);
  const [isInputDisabled, setIsInputDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open && website) {
      clearScrappedData();
      getWebScrapDet(); // 🔥 auto-fetch data when modal opens
    }
  }, [open, website]);

  if (!open) return null;

  const clearScrappedData = () => {
    setIsInputDisabled(false);
    setSocialLinks([]);
    setAboutList([]);
    setWebScrapDetails({});
    setServicesList([]);
    setIndustriesList([]);
    setProductsList([]);
    setTeamsList([]);
    setParnterList([]);
    setPageDetails([]);
    setPageLinList([]);
    setClientList([]);
    setPeopleList([]);
    setCareersList({});
    setErrorMsg({}); // clear errors
  };

  const normalizeKey = (key = "") => {
    return key
      .replace(".com", "")
      .replace("www.", "")
      .replace("https://", "")
      .replace("http://", "")
      .split(".")[0]
      .toLowerCase();
  };

  const createSocialLinks = (socialMediaObj = {}) => {
    return Object.entries(socialMediaObj).map(([key, url]) => {
      const normalized = normalizeKey(key); // convert key to instagram/facebook etc.

      return {
        name: extractHandle(url), // handle like @lenteratechnologies
        icon: socialIcons[normalized] || null,
        url,
      };
    });
  };

  const sections = [
    { label: "Details", value: webScrapDetails },
    { label: "Services", value: serviceList },
    { label: "Industries", value: industriesList },
    { label: "Products", value: productsList },
    { label: "About", value: webScrapDetails?.about ?? aboutList },
    { label: "Teams", value: teamList },
    { label: "Partners", value: partnerList },
    { label: "Pages Link", value: payLinkList },
    { label: "Clients", value: clientList },
    { label: "People", value: peopleList },
    { label: "Careers", value: careersList },
  ];

  const extractHandle = (url = "") => {
    if (!url) return "";

    // Remove protocol & www
    let clean = url.replace(/https?:\/\/(www\.)?/i, "").replace(/\/$/, "");

    if (clean.includes("linkedin.com")) {
      const parts = clean.split("/");
      return parts[2] || ""; // after /company/
    }

    // Default logic for facebook/instagram/twitter
    clean = clean.replace(/\.[a-z]+/i, "");
    return clean.split("/")[1] || clean;
  };

  const socialIcons = {
    linkedin: <LinIC />,
    facebook: <FasIC />,
    x: <XIC />,
    twitter: <XIC />,
    instagram: <InstaIc />,
    youtube: <YoutIC />,
  };

  const getWebScrapDet = async () => {
    try {
      setIsLoading(true);
      setIsInputDisabled(true);
      setErrorMsg({
        url: "",
      });
      const bodyData = {
        url: website,
      };

      const response = await getWebScrapingApi(bodyData);
      console.log({ response });

      if (response.data.success === true) {
        setIsLoading(true);

        let webScap = response.data.data ?? {};
        setSocialLinks(
          createSocialLinks(response.data.data?.social_links ?? {}),
        );
        setWebScrapDetails(webScap ?? {});
        setServicesList(webScap.services ?? []);
        setIndustriesList(webScap.industries ?? []);
        setProductsList(webScap.products ?? []);
        setTeamsList(webScap.team ?? []);
        setParnterList(webScap.partners ?? []);
        setPageDetails(webScap.total_pages ?? []);
        setPageLinList(webScap.pages ?? []);
        setClientList(webScap.clients ?? []);
        setPeopleList(webScap.people ?? []);
        setCareersList(webScap.careers ?? {});
      }
      if (response.status === 400) {
        const validationTemp = {
          url: "",
        };
        Object.entries(response.data.error).forEach(([key, value]) => {
          if (key in validationTemp) {
            validationTemp[key] =
              Array.isArray(value) && value.length > 0 ? value[0] : "";
          }
        });
        setErrorMsg(validationTemp);
      }
    } catch (err) {
      console.error("Error fetching lead details:", err);
    } finally {
      setIsLoading(false); // stop loader always
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose} // 👉 clicking outside closes modal
    >
      <div
        style={{
          backgroundColor: "#FFFFFF",
          width: "812px",
          borderRadius: "16px",
          overflow: "hidden",
        }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 600,
            fontSize: 16,
            color: "#172B4D",
            border: "1px solid #EBEBEB",
            backgroundColor: "#F5F7F9",
            width: "100%",
            padding: "12px 20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                fontSize: "16px",
                fontWeight: "500",
                marginLeft: "10px",
              }}
            >
              Website Link
            </div>
          </div>

          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <CloseModal onClick={onClose} style={{ cursor: "pointer" }} />
          </div>
        </div>

        {/* CONTENT */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 600,
            fontSize: 16,
            color: "#172B4D",
            margin: "20px",
            padding: "12px",
            border: "1px solid #EBEBEB",
            backgroundColor: "#F0F1FF",
            borderRadius: "24px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <WebsiteIC />
            <div
              style={{
                color: "#3D4AF5",
                fontSize: "16px",
                fontWeight: "500",
                marginLeft: "10px",
                wordBreak: "break-all",
              }}
            >
              {website}
            </div>
          </div>

          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <WebsiteEditIC onClick={onEdit} style={{ cursor: "pointer" }} />
          </div>
        </div>

        <div style={{ height: "383px", overflowY: "auto", padding: "24px" }}>
          <WebsiteDetailsWidget
            webScrapDetails={webScrapDetails}
            sections={sections}
            socialLinks={socialLinks}
            serviceList={serviceList}
            industriesList={industriesList}
            productsList={productsList}
            teamList={teamList}
            partnerList={partnerList}
            payLinkDetails={payLinkDetails}
            payLinkList={payLinkList}
            aboutList={aboutList}
            clientList={clientList}
            peopleList={peopleList}
            careersList={careersList}
            teamGrid={"2"}
            sourcePage="view"
            enableDelete={false}
          />
        </div>

        {/* FOOTER BUTTONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "16px 24px",
            borderTop: "1px solid #EBEBEB",
            backgroundColor: "#fff",
          }}
        >
          <button
            onClick={() => {
              setIsLoading(true);
              onDataSubmit(website, webScrapDetails);
            }}
            style={{
              padding: "10px 24px",
              backgroundColor: "#3D4AF5",
              color: "#fff",
              borderRadius: "8px",
              border: "none",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Submit
          </button>
        </div>
      </div>

      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "18px",
            fontWeight: "600",
            zIndex: 50,
          }}
        >
          Loading...
        </div>
      )}
    </div>
  );
}
